module.exports = __webpack_public_path__ + "fonts/Inter-600-greek-ext59.af80f40.woff2";